import { Navigation, Search } from 'lucide-react'
import { myLocationShown } from '../../utils/mapMyLocation'
import { OrellaSpinner } from '../OrellaLoader' // s123: the app's one spinner

/**
 * MapAreaButtons — s106: the two buttons over a doctor map, shared by the share step and the
 * Doctors tab (useMapArea holds the state). "Search this area" while the patient has moved the map;
 * "My location" while an area is searched and no pin card covers the corner (`showMyLocation`).
 * Existing copy only (share.searchThisArea, share.backToMyLocation).
 *
 * ★ PROD-1184 (Alex 2026-10-19, Doctors tab: panned out to the ocean, no one-tap way back). "My location"
 *   shows whenever the map is away from the patient's point (device, searched address or home ZIP):
 *   after they move it, not only after an area search. A caller that passes
 *   `cardOpen` keeps it while a pin card is open: the card covers the bottom of the map, so it moves
 *   to the top-left corner as a round icon button drawn above the card (zIndex 6 > the card's 5),
 *   clear of the centred "Search this area". Both maps (Doctors tab, share step) pass it.
 */
export default function MapAreaButtons({ mapArea, showMyLocation = true, cardOpen = null, t }) {
  const { areaView, area, areaBusy, searchThisArea, clearArea, auto } = mapArea
  const myLocation = myLocationShown({ area, areaView }) && showMyLocation
  const myLocationLabel = t('share.backToMyLocation', 'My location')
  return (
    <>
      {/* s123: with the automatic refresh (useMapArea auto, the default) the button is not drawn. */}
      {areaView && !auto && (
        <button type="button" onClick={searchThisArea} data-cta="map-search-area" disabled={areaBusy}
          className="absolute left-1/2 -translate-x-1/2 top-2.5 px-3.5 py-1.5 rounded-full text-[12.5px] font-bold text-white shadow-md flex items-center gap-1.5"
          style={{ background: '#15354F', zIndex: 6 }}>
          {areaBusy ? <OrellaSpinner size={16} tone="inherit" /> : <Search size={13} />}
          {t('share.searchThisArea', 'Search this area')}
        </button>
      )}
      {myLocation && !cardOpen && (
        <button type="button" onClick={clearArea} data-cta="map-my-location"
          className="absolute left-2.5 bottom-2.5 px-3 py-1.5 rounded-full text-[12px] font-bold bg-white shadow flex items-center gap-1.5"
          style={{ color: '#15354F', border: '1px solid #E7EEF4' }}>
          <Navigation size={12} /> {myLocationLabel}
        </button>
      )}
      {myLocation && cardOpen && (
        <button type="button" onClick={clearArea} data-cta="map-my-location" aria-label={myLocationLabel} title={myLocationLabel}
          className="absolute left-2.5 top-2.5 w-8 h-8 rounded-full bg-white shadow grid place-items-center"
          style={{ color: '#15354F', border: '1px solid #E7EEF4', zIndex: 6 }}>
          <Navigation size={14} />
        </button>
      )}
    </>
  )
}
